export default `
	headline
	primaryImage {
		size
		width
		height
		filename
		url(transform:coverImageXL)
	}
	caption
`;
